import { Route, Routes, Navigate } from "react-router";
import { Toaster } from "@bloom/ui";
import { isAdminRole, type Role } from "@bloom/types";
import { AdminShell } from "./layout/shell.tsx";
import { LoginPage } from "./routes/login.tsx";
import { DashboardPage } from "./routes/dashboard.tsx";
import { SeriesIndex } from "./routes/series-index.tsx";
import { SeriesEditor } from "./routes/series-editor.tsx";
import { PricingPage } from "./routes/pricing.tsx";
import { SalesPage } from "./routes/sales.tsx";
import { AuditLogPage } from "./routes/audit-log.tsx";
import { UsersIndex } from "./routes/users-index.tsx";
import { UserDetail } from "./routes/user-detail.tsx";
import { useAuth } from "./auth/auth-context.tsx";
import type { ReactNode } from "react";

export function AdminApp() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <RequireAdmin>
              <AdminShell>
                <Routes>
                  <Route index element={<DashboardPage />} />
                  <Route path="series" element={<SeriesIndex />} />
                  <Route path="series/new" element={<SeriesEditor />} />
                  <Route path="series/:id" element={<SeriesEditor />} />
                  <Route path="users" element={<UsersIndex />} />
                  <Route path="users/:id" element={<UserDetail />} />
                  <Route path="pricing" element={<PricingPage />} />
                  <Route path="sales" element={<SalesPage />} />
                  <Route path="audit-log" element={<AuditLogPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </AdminShell>
            </RequireAdmin>
          }
        />
      </Routes>
      <Toaster />
    </>
  );
}

function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="p-10 text-sm text-[var(--brand-muted)]">…</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (!isAdminRole(user.role as Role)) {
    return (
      <div className="mx-auto max-w-md p-12 text-center">
        <p>You don't have admin access.</p>
      </div>
    );
  }
  return <>{children}</>;
}
